import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const { coachingDashboard } = appStrings.modules;

export type WireNamed = Readonly<{
  first_name: string | null;
  last_name: string | null;
}>;

const namedParts = (person: WireNamed): string[] =>
  [person.first_name, person.last_name]
    .map((part) => part?.trim() ?? '')
    .filter((part) => part !== '');

export const personInitial = (person: WireNamed): string => namedParts(person)[0]?.charAt(0) ?? '';

export const personName = (person: WireNamed): string => {
  const parts = namedParts(person);

  return parts.length === 0 ? coachingDashboard.unnamedPerson : parts.join(' ');
};
